// src/utils/regexValidators.js

export const regexValidators = {
    // Name: Alphabets and spaces, 1–30 characters
    name: /^[a-zA-Z\s]{1,30}$/,
  
    //  Email: Basic format
    email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  
    //  Indian Phone Number: 10 digits
        phone: /^\d{10}$/,
    //  Employee ID: Alphanumeric, underscores, dashes, up to 20 chars
    empId: /^[a-zA-Z0-9_-]{1,20}$/,
  
    //  PAN Card (India)
    pan: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  
    //  Aadhaar Number (India)
    aadhaar: /^\d{4}\s\d{4}\s\d{4}$/,
  
    //  GSTIN (India)
    gstin: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  
    // PIN Code (India)
    pincode: /^\d{6}$/,
 
  
    //  Strong Password (min 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special)
    strongPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  
    //  Numbers Only
    numericOnly: /^\d+$/,
  
    //  Letters Only
    alphabetOnly: /^[A-Za-z]+$/,
  
    // Address: Alphanumeric, punctuation, up to 160 chars
    address: /^[a-zA-Z0-9\s,.'-]{1,160}$/,

  
    // Credit Card (basic check)
    creditCard: /^\d{4}-?\d{4}-?\d{4}-?\d{4}$/,
  
  
    hexColor: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
  
    //  Team or Role Description
    description: /^[a-zA-Z0-9\s,.'-]{1,100}$/,
  

  };
  
  export const validateInput = (type, value) => {
    const regex = regexValidators[type];
    if (!regex) throw new Error(`No regex for type: ${type}`);
    return regex.test(value);
  };
  